// ----------------------------------------------------------------------------
// Component: Animation Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_animation-block.scss';